import React from "react";
import { Loader, Table } from "semantic-ui-react";
import CurrencyFormat from "react-currency-format";

interface IChargesTable {
  print?: boolean;
  feeList?: IFeeListItem[];
  activeFees: number;
  type?: "payment" | "permits-waive-fee";
  pending: number;
  paid: number;
  balance: number | undefined;
  mainAmount?: number;
  subtotal?: number;
  user?: "citizen";
}
export interface IFeeListItem {
  active: boolean;
  amount: number;
  created_at: string;
  fee_item_id: unknown | null;
  id: number;
  order: unknown | null;
  title: string;
  subtotal: boolean;
  type: "permits-charge" | "permits-waive-fee";
}
export const ChargesTable = ({
  feeList,
  activeFees,
  balance,
  mainAmount,
  paid,
  pending,
  user,
  print,
  subtotal,
  type = "payment",
}: IChargesTable) => {
  const subtotalFees = feeList?.filter((fee) => fee.subtotal) ?? [];
  const hasSubtotalFees = subtotalFees.length !== 0;
  return (
    <Table size='small' style={{ fontSize: 14 }}>
      {user !== "citizen" && !print && (
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Line item</Table.HeaderCell>
            <Table.HeaderCell />
            <Table.HeaderCell collapsing>Amount</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
      )}
      <Table.Body>
        {feeList
          ?.filter((fee) => !fee.subtotal)
          .map((fee, index: number) => {
            return (
              <Table.Row className='tw-indent-4' key={index}>
                <Table.Cell className='capitalize'>{fee.title}</Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell className='align-table-cell-right'>
                  <CurrencyFormat
                    value={fee.type == "permits-waive-fee" ? fee.amount / -100 : fee.amount / 100}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    displayType={"text"}
                    prefix={"$"}
                    thousandSeparator={true}
                  />
                </Table.Cell>
              </Table.Row>
            );
          })}
        {hasSubtotalFees && (
          <Table.Row>
            <Table.Cell className='bold uppercase'>Subtotal</Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell className='bold align-table-cell-right'>
              <CurrencyFormat
                value={(subtotal ?? 0) / 100 || 0}
                fixedDecimalScale={true}
                decimalScale={2}
                displayType={"text"}
                prefix={"$"}
                thousandSeparator={true}
              />
            </Table.Cell>
          </Table.Row>
        )}
        {hasSubtotalFees &&
          subtotalFees.map((fee, index: number) => {
            return (
              <Table.Row className='tw-indent-4' key={index}>
                <Table.Cell className='capitalize'>{fee.title}</Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell className='align-table-cell-right'>
                  <CurrencyFormat
                    value={fee.type == "permits-waive-fee" ? fee.amount / -100 : fee.amount / 100}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    displayType={"text"}
                    prefix={"$"}
                    thousandSeparator={true}
                  />
                </Table.Cell>
              </Table.Row>
            );
          })}
        <Table.Row>
          <Table.Cell className='bold uppercase'>total</Table.Cell>
          <Table.Cell></Table.Cell>
          <Table.Cell className='bold align-table-cell-right'>
            <CurrencyFormat
              value={activeFees / 100 || mainAmount || 0}
              fixedDecimalScale={true}
              decimalScale={2}
              displayType={"text"}
              prefix={"$"}
              thousandSeparator={true}
            />
          </Table.Cell>
        </Table.Row>
        {type === "payment" && (
          <Table.Row>
            <Table.Cell className='bold uppercase'>paid</Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell className='bold align-table-cell-right'>
              <CurrencyFormat
                value={paid / 100 || 0}
                fixedDecimalScale={true}
                decimalScale={2}
                displayType={"text"}
                prefix={"$"}
                thousandSeparator={true}
              />
            </Table.Cell>
          </Table.Row>
        )}
        {type === "payment" && pending !== 0 && (
          <Table.Row>
            <Table.Cell className='bold uppercase'>
              pending <Loader active />{" "}
            </Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell className='bold align-table-cell-right'>
              <CurrencyFormat
                value={pending / 100 || 0}
                fixedDecimalScale={true}
                decimalScale={2}
                displayType={"text"}
                prefix={"$"}
                thousandSeparator={true}
              />
            </Table.Cell>
          </Table.Row>
        )}
        {type === "payment" && (
          <Table.Row>
            <Table.Cell className='bold uppercase'>balance due</Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell className='bold align-table-cell-right'>
              <CurrencyFormat
                value={balance ? balance / 100 : 0}
                fixedDecimalScale={true}
                decimalScale={2}
                displayType={"text"}
                prefix={"$"}
                thousandSeparator={true}
              />
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
  );
};
